import { render, staticRenderFns } from "./Bauprojekte.vue?vue&type=template&id=63510369&scoped=true&"
import script from "./Bauprojekte.vue?vue&type=script&lang=js&"
export * from "./Bauprojekte.vue?vue&type=script&lang=js&"
import style0 from "./Bauprojekte.vue?vue&type=style&index=0&id=63510369&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63510369",
  null
  
)

export default component.exports